"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackTxResponseToJSON = exports.trackTxResponseFromJSON = exports.trackTxRequestToJSON = exports.trackTxRequestFromJSON = exports.submitTxResponseToJSON = exports.submitTxResponseFromJSON = exports.submitTxRequestToJSON = exports.submitTxRequestFromJSON = exports.multiChainMsgToJSON = exports.multiChainMsgFromJSON = exports.msgsRequestToJSON = exports.msgsRequestFromJSON = exports.postHandlerToJSON = exports.postHandlerFromJSON = exports.cosmWasmContractMsgToJSON = exports.cosmWasmContractMsgFromJSON = exports.routeResponseToJSON = exports.routeResponseFromJSON = exports.operationToJSON = exports.operationFromJSON = exports.swapToJSON = exports.swapFromJSON = exports.swapExactCoinOutToJSON = exports.swapExactCoinOutFromJSON = exports.swapExactCoinInToJSON = exports.swapExactCoinInFromJSON = exports.swapOperationToJSON = exports.swapOperationFromJSON = exports.transferToJSON = exports.transferFromJSON = exports.routeRequestToJSON = exports.routeRequestFromJSON = exports.swapVenueToJSON = exports.swapVenueFromJSON = exports.recommendAssetsRequestToJSON = exports.recommendAssetsRequestFromJSON = exports.feeAssetToJSON = exports.feeAssetFromJSON = exports.chainToJSON = exports.chainFromJSON = exports.assetsRequestToJSON = exports.assetsRequestFromJSON = exports.assetsFromSourceRequestToJSON = exports.assetsFromSourceRequestFromJSON = exports.assetRecommendationToJSON = exports.assetRecommendationFromJSON = exports.assetToJSON = exports.assetFromJSON = exports.affiliateToJSON = exports.affiliateFromJSON = void 0;
exports.transferStatusToJSON = exports.transferStatusFromJSON = exports.transferEventToJSON = exports.transferEventFromJSON = exports.axelarTransferInfoToJSON = exports.axelarTransferInfoFromJSON = exports.axelarTransferTransactionsToJSON = exports.axelarTransferTransactionsFromJSON = exports.contractCallWithTokenTransactionsToJSON = exports.contractCallWithTokenTransactionsFromJSON = exports.sendTokenTransactionsToJSON = exports.sendTokenTransactionsFromJSON = exports.msgToJSON = exports.msgFromJSON = exports.evmTxToJSON = exports.evmTxFromJSON = exports.erc20ApprovalToJSON = exports.erc20ApprovalFromJSON = exports.axelarTransferToJSON = exports.axelarTransferFromJSON = exports.ibcAddressToJSON = exports.ibcAddressFromJSON = exports.txStatusResponseToJSON = exports.txStatusResponseFromJSON = exports.transferAssetReleaseToJSON = exports.transferAssetReleaseFromJSON = exports.nextBlockingTransferToJSON = exports.nextBlockingTransferFromJSON = exports.transferInfoToJSON = exports.transferInfoFromJSON = exports.packetToJSON = exports.packetFromJSON = exports.chainTransactionToJSON = exports.chainTransactionFromJSON = exports.txStatusRequestToJSON = exports.txStatusRequestFromJSON = void 0;
function affiliateFromJSON(affiliateJSON) {
    return {
        address: affiliateJSON.address,
        basisPointsFee: affiliateJSON.basis_points_fee,
    };
}
exports.affiliateFromJSON = affiliateFromJSON;
function affiliateToJSON(affiliate) {
    return {
        address: affiliate.address,
        basis_points_fee: affiliate.basisPointsFee,
    };
}
exports.affiliateToJSON = affiliateToJSON;
function assetFromJSON(assetJSON) {
    return {
        denom: assetJSON.denom,
        chainID: assetJSON.chain_id,
        originDenom: assetJSON.origin_denom,
        originChainID: assetJSON.origin_chain_id,
        trace: assetJSON.trace,
        isCW20: assetJSON.is_cw20,
        symbol: assetJSON.symbol,
        name: assetJSON.name,
        logoURI: assetJSON.logo_uri,
        decimals: assetJSON.decimals,
        tokenContract: assetJSON.token_contract,
        description: assetJSON.description,
        coingeckoID: assetJSON.coingecko_id,
        recommendedSymbol: assetJSON.recommended_symbol
    };
}
exports.assetFromJSON = assetFromJSON;
function assetToJSON(asset) {
    return {
        denom: asset.denom,
        chain_id: asset.chainID,
        origin_denom: asset.originDenom,
        origin_chain_id: asset.originChainID,
        trace: asset.trace,
        is_cw20: asset.isCW20,
        symbol: asset.symbol,
        name: asset.name,
        logo_uri: asset.logoURI,
        decimals: asset.decimals,
        token_contract: asset.tokenContract,
        description: asset.description,
        coingecko_id: asset.coingeckoID,
        recommended_symbol: asset.recommendedSymbol
    };
}
exports.assetToJSON = assetToJSON;
function assetRecommendationFromJSON(assetRecommendationJSON) {
    return {
        asset: assetFromJSON(assetRecommendationJSON.asset),
        reason: assetRecommendationJSON.reason,
    };
}
exports.assetRecommendationFromJSON = assetRecommendationFromJSON;
function assetRecommendationToJSON(assetRecommendation) {
    return {
        asset: assetToJSON(assetRecommendation.asset),
        reason: assetRecommendation.reason,
    };
}
exports.assetRecommendationToJSON = assetRecommendationToJSON;
function assetsFromSourceRequestFromJSON(assetsFromSourceRequestJSON) {
    var _a;
    return {
        sourceAssetDenom: assetsFromSourceRequestJSON.source_asset_denom,
        sourceAssetChainID: assetsFromSourceRequestJSON.source_asset_chain_id,
        allowMultiTx: assetsFromSourceRequestJSON.allow_multi_tx,
        recommendationReason: assetsFromSourceRequestJSON.recommendation_reason,
        includeSwaps: assetsFromSourceRequestJSON.include_swaps,
        swapVenues: (_a = assetsFromSourceRequestJSON.swap_venues) === null || _a === void 0 ? void 0 : _a.map(swapVenueFromJSON),
        nativeOnly: assetsFromSourceRequestJSON.native_only,
        groupBy: assetsFromSourceRequestJSON.group_by,
        includeCW20Assets: assetsFromSourceRequestJSON.include_cw20_assets,
        clientID: assetsFromSourceRequestJSON.client_id,
    };
}
exports.assetsFromSourceRequestFromJSON = assetsFromSourceRequestFromJSON;
function assetsFromSourceRequestToJSON(assetsFromSourceRequest) {
    var _a;
    return {
        source_asset_denom: assetsFromSourceRequest.sourceAssetDenom,
        source_asset_chain_id: assetsFromSourceRequest.sourceAssetChainID,
        allow_multi_tx: assetsFromSourceRequest.allowMultiTx,
        recommendation_reason: assetsFromSourceRequest.recommendationReason,
        include_swaps: assetsFromSourceRequest.includeSwaps,
        swap_venues: (_a = assetsFromSourceRequest.swapVenues) === null || _a === void 0 ? void 0 : _a.map(swapVenueToJSON),
        native_only: assetsFromSourceRequest.nativeOnly,
        group_by: assetsFromSourceRequest.groupBy,
        include_cw20_assets: assetsFromSourceRequest.includeCW20Assets,
        client_id: assetsFromSourceRequest.clientID,
    };
}
exports.assetsFromSourceRequestToJSON = assetsFromSourceRequestToJSON;
function assetsRequestFromJSON(assetsRequestJSON) {
    return {
        chainID: assetsRequestJSON.chain_id,
        nativeOnly: assetsRequestJSON.native_only,
        includeNoMetadataAssets: assetsRequestJSON.include_no_metadata_assets,
        includeCW20Assets: assetsRequestJSON.include_cw20_assets,
        includeEvmAssets: assetsRequestJSON.include_evm_assets,
        clientID: assetsRequestJSON.client_id,
    };
}
exports.assetsRequestFromJSON = assetsRequestFromJSON;
function assetsRequestToJSON(assetsRequest) {
    return {
        chain_id: assetsRequest.chainID,
        native_only: assetsRequest.nativeOnly,
        include_no_metadata_assets: assetsRequest.includeNoMetadataAssets,
        include_cw20_assets: assetsRequest.includeCW20Assets,
        include_evm_assets: assetsRequest.includeEvmAssets,
        client_id: assetsRequest.clientID,
    };
}
exports.assetsRequestToJSON = assetsRequestToJSON;
function chainFromJSON(chainJSON) {
    return {
        chainName: chainJSON.chain_name,
        chainID: chainJSON.chain_id,
        pfmEnabled: chainJSON.pfm_enabled,
        cosmosSDKVersion: chainJSON.cosmos_sdk_version,
        modules: chainJSON.modules,
        cosmosModuleSupport: chainJSON.cosmos_module_support,
        supportsMemo: chainJSON.supports_memo,
        logoURI: chainJSON.logo_uri,
        bech32Prefix: chainJSON.bech32_prefix,
        feeAssets: chainJSON.fee_assets.map(feeAssetFromJSON),
        chainType: chainJSON.chain_type,
    };
}
exports.chainFromJSON = chainFromJSON;
function chainToJSON(chain) {
    return {
        chain_name: chain.chainName,
        chain_id: chain.chainID,
        pfm_enabled: chain.pfmEnabled,
        cosmos_sdk_version: chain.cosmosSDKVersion,
        modules: chain.modules,
        cosmos_module_support: chain.cosmosModuleSupport,
        supports_memo: chain.supportsMemo,
        logo_uri: chain.logoURI,
        bech32_prefix: chain.bech32Prefix,
        fee_assets: chain.feeAssets.map(feeAssetToJSON),
        chain_type: chain.chainType,
    };
}
exports.chainToJSON = chainToJSON;
function feeAssetFromJSON(feeAssetJSON) {
    return {
        denom: feeAssetJSON.denom,
        gasPrice: feeAssetJSON.gas_price,
    };
}
exports.feeAssetFromJSON = feeAssetFromJSON;
function feeAssetToJSON(feeAsset) {
    return {
        denom: feeAsset.denom,
        gas_price: feeAsset.gasPrice,
    };
}
exports.feeAssetToJSON = feeAssetToJSON;
function recommendAssetsRequestFromJSON(recommendAssetsRequestJSON) {
    return {
        sourceAssetDenom: recommendAssetsRequestJSON.source_asset_denom,
        sourceAssetChainID: recommendAssetsRequestJSON.source_asset_chain_id,
        destChainID: recommendAssetsRequestJSON.dest_chain_id,
        reason: recommendAssetsRequestJSON.reason,
        clientID: recommendAssetsRequestJSON.client_id,
    };
}
exports.recommendAssetsRequestFromJSON = recommendAssetsRequestFromJSON;
function recommendAssetsRequestToJSON(recommendAssetsRequest) {
    return {
        source_asset_denom: recommendAssetsRequest.sourceAssetDenom,
        source_asset_chain_id: recommendAssetsRequest.sourceAssetChainID,
        dest_chain_id: recommendAssetsRequest.destChainID,
        reason: recommendAssetsRequest.reason,
        client_id: recommendAssetsRequest.clientID,
    };
}
exports.recommendAssetsRequestToJSON = recommendAssetsRequestToJSON;
function swapVenueFromJSON(swapVenueJSON) {
    return {
        name: swapVenueJSON.name,
        chainID: swapVenueJSON.chain_id,
    };
}
exports.swapVenueFromJSON = swapVenueFromJSON;
function swapVenueToJSON(swapVenue) {
    return {
        name: swapVenue.name,
        chain_id: swapVenue.chainID,
    };
}
exports.swapVenueToJSON = swapVenueToJSON;
function routeRequestFromJSON(routeRequestJSON) {
    if (routeRequestJSON.amount_in !== undefined) {
        return {
            sourceAssetDenom: routeRequestJSON.source_asset_denom,
            sourceAssetChainID: routeRequestJSON.source_asset_chain_id,
            destAssetDenom: routeRequestJSON.dest_asset_denom,
            destAssetChainID: routeRequestJSON.dest_asset_chain_id,
            amountIn: routeRequestJSON.amount_in,
            cumulativeAffiliateFeeBPS: routeRequestJSON.cumulative_affiliate_fee_bps,
            swapVenue: routeRequestJSON.swap_venue
                ? swapVenueFromJSON(routeRequestJSON.swap_venue)
                : undefined,
            clientID: routeRequestJSON.client_id,
        };
    }
    return {
        sourceAssetDenom: routeRequestJSON.source_asset_denom,
        sourceAssetChainID: routeRequestJSON.source_asset_chain_id,
        destAssetDenom: routeRequestJSON.dest_asset_denom,
        destAssetChainID: routeRequestJSON.dest_asset_chain_id,
        amountOut: routeRequestJSON.amount_out,
        cumulativeAffiliateFeeBPS: routeRequestJSON.cumulative_affiliate_fee_bps,
        swapVenue: routeRequestJSON.swap_venue
            ? swapVenueFromJSON(routeRequestJSON.swap_venue)
            : undefined,
        clientID: routeRequestJSON.client_id,
    };
}
exports.routeRequestFromJSON = routeRequestFromJSON;
function routeRequestToJSON(routeRequest) {
    if (routeRequest.amountIn !== undefined) {
        return {
            source_asset_denom: routeRequest.sourceAssetDenom,
            source_asset_chain_id: routeRequest.sourceAssetChainID,
            dest_asset_denom: routeRequest.destAssetDenom,
            dest_asset_chain_id: routeRequest.destAssetChainID,
            amount_in: routeRequest.amountIn,
            cumulative_affiliate_fee_bps: routeRequest.cumulativeAffiliateFeeBPS,
            swap_venue: routeRequest.swapVenue
                ? swapVenueToJSON(routeRequest.swapVenue)
                : undefined,
            client_id: routeRequest.clientID,
        };
    }
    return {
        source_asset_denom: routeRequest.sourceAssetDenom,
        source_asset_chain_id: routeRequest.sourceAssetChainID,
        dest_asset_denom: routeRequest.destAssetDenom,
        dest_asset_chain_id: routeRequest.destAssetChainID,
        amount_out: routeRequest.amountOut,
        cumulative_affiliate_fee_bps: routeRequest.cumulativeAffiliateFeeBPS,
        swap_venue: routeRequest.swapVenue
            ? swapVenueToJSON(routeRequest.swapVenue)
            : undefined,
        client_id: routeRequest.clientID,
    };
}
exports.routeRequestToJSON = routeRequestToJSON;
function transferFromJSON(transferJSON) {
    return {
        port: transferJSON.port,
        channel: transferJSON.channel,
        chainID: transferJSON.chain_id,
        pfmEnabled: transferJSON.pfm_enabled,
        destDenom: transferJSON.dest_denom,
        supportsMemo: transferJSON.supports_memo,
    };
}
exports.transferFromJSON = transferFromJSON;
function transferToJSON(transfer) {
    return {
        port: transfer.port,
        channel: transfer.channel,
        chain_id: transfer.chainID,
        pfm_enabled: transfer.pfmEnabled,
        dest_denom: transfer.destDenom,
        supports_memo: transfer.supportsMemo,
    };
}
exports.transferToJSON = transferToJSON;
function swapOperationFromJSON(swapOperationJSON) {
    return {
        pool: swapOperationJSON.pool,
        denomIn: swapOperationJSON.denom_in,
        denomOut: swapOperationJSON.denom_out,
    };
}
exports.swapOperationFromJSON = swapOperationFromJSON;
function swapOperationToJSON(swapOperation) {
    return {
        pool: swapOperation.pool,
        denom_in: swapOperation.denomIn,
        denom_out: swapOperation.denomOut,
    };
}
exports.swapOperationToJSON = swapOperationToJSON;
function swapExactCoinInFromJSON(swapExactCoinInJSON) {
    return {
        swapVenue: swapVenueFromJSON(swapExactCoinInJSON.swap_venue),
        swapOperations: swapExactCoinInJSON.swap_operations.map(swapOperationFromJSON),
        swapAmountIn: swapExactCoinInJSON.swap_amount_in,
    };
}
exports.swapExactCoinInFromJSON = swapExactCoinInFromJSON;
function swapExactCoinInToJSON(swapExactCoinIn) {
    return {
        swap_venue: swapVenueToJSON(swapExactCoinIn.swapVenue),
        swap_operations: swapExactCoinIn.swapOperations.map(swapOperationToJSON),
        swap_amount_in: swapExactCoinIn.swapAmountIn,
    };
}
exports.swapExactCoinInToJSON = swapExactCoinInToJSON;
function swapExactCoinOutFromJSON(swapExactCoinOutJSON) {
    return {
        swapVenue: swapVenueFromJSON(swapExactCoinOutJSON.swap_venue),
        swapOperations: swapExactCoinOutJSON.swap_operations.map(swapOperationFromJSON),
        swapAmountOut: swapExactCoinOutJSON.swap_amount_out,
    };
}
exports.swapExactCoinOutFromJSON = swapExactCoinOutFromJSON;
function swapExactCoinOutToJSON(swapExactCoinOut) {
    return {
        swap_venue: swapVenueToJSON(swapExactCoinOut.swapVenue),
        swap_operations: swapExactCoinOut.swapOperations.map(swapOperationToJSON),
        swap_amount_out: swapExactCoinOut.swapAmountOut,
    };
}
exports.swapExactCoinOutToJSON = swapExactCoinOutToJSON;
function swapFromJSON(swapJSON) {
    if ("swap_in" in swapJSON) {
        return {
            swapIn: swapExactCoinInFromJSON(swapJSON.swap_in),
            estimatedAffiliateFee: swapJSON.estimated_affiliate_fee,
        };
    }
    return {
        swapOut: swapExactCoinOutFromJSON(swapJSON.swap_out),
        estimatedAffiliateFee: swapJSON.estimated_affiliate_fee,
    };
}
exports.swapFromJSON = swapFromJSON;
function swapToJSON(swap) {
    if ("swapIn" in swap) {
        return {
            swap_in: swapExactCoinInToJSON(swap.swapIn),
            estimated_affiliate_fee: swap.estimatedAffiliateFee,
        };
    }
    return {
        swap_out: swapExactCoinOutToJSON(swap.swapOut),
        estimated_affiliate_fee: swap.estimatedAffiliateFee,
    };
}
exports.swapToJSON = swapToJSON;
function operationFromJSON(operationJSON) {
    if ("transfer" in operationJSON) {
        return { transfer: transferFromJSON(operationJSON.transfer) };
    }
    if ("axelar_transfer" in operationJSON) {
        return {
            axelarTransfer: axelarTransferFromJSON(operationJSON.axelar_transfer),
        };
    }
    return { swap: swapFromJSON(operationJSON.swap) };
}
exports.operationFromJSON = operationFromJSON;
function operationToJSON(operation) {
    if ("transfer" in operation) {
        return { transfer: transferToJSON(operation.transfer) };
    }
    if ("axelarTransfer" in operation) {
        return { axelar_transfer: axelarTransferToJSON(operation.axelarTransfer) };
    }
    return { swap: swapToJSON(operation.swap) };
}
exports.operationToJSON = operationToJSON;
function routeResponseFromJSON(routeResponseJSON) {
    return {
        sourceAssetDenom: routeResponseJSON.source_asset_denom,
        sourceAssetChainID: routeResponseJSON.source_asset_chain_id,
        destAssetDenom: routeResponseJSON.dest_asset_denom,
        destAssetChainID: routeResponseJSON.dest_asset_chain_id,
        amountIn: routeResponseJSON.amount_in,
        amountOut: routeResponseJSON.amount_out,
        operations: routeResponseJSON.operations.map(operationFromJSON),
        chainIDs: routeResponseJSON.chain_ids,
        doesSwap: routeResponseJSON.does_swap,
        estimatedAmountOut: routeResponseJSON.estimated_amount_out,
        swapVenue: routeResponseJSON.swap_venue
            ? swapVenueFromJSON(routeResponseJSON.swap_venue)
            : undefined,
        txsRequired: routeResponseJSON.txs_required,
    };
}
exports.routeResponseFromJSON = routeResponseFromJSON;
function routeResponseToJSON(routeResponse) {
    return {
        source_asset_denom: routeResponse.sourceAssetDenom,
        source_asset_chain_id: routeResponse.sourceAssetChainID,
        dest_asset_denom: routeResponse.destAssetDenom,
        dest_asset_chain_id: routeResponse.destAssetChainID,
        amount_in: routeResponse.amountIn,
        amount_out: routeResponse.amountOut,
        operations: routeResponse.operations.map(operationToJSON),
        chain_ids: routeResponse.chainIDs,
        does_swap: routeResponse.doesSwap,
        estimated_amount_out: routeResponse.estimatedAmountOut,
        swap_venue: routeResponse.swapVenue
            ? swapVenueToJSON(routeResponse.swapVenue)
            : undefined,
        txs_required: routeResponse.txsRequired,
    };
}
exports.routeResponseToJSON = routeResponseToJSON;
function cosmWasmContractMsgFromJSON(cosmWasmContractMsgJSON) {
    return {
        contractAddress: cosmWasmContractMsgJSON.contract_address,
        msg: cosmWasmContractMsgJSON.msg,
    };
}
exports.cosmWasmContractMsgFromJSON = cosmWasmContractMsgFromJSON;
function cosmWasmContractMsgToJSON(cosmWasmContractMsg) {
    return {
        contract_address: cosmWasmContractMsg.contractAddress,
        msg: cosmWasmContractMsg.msg,
    };
}
exports.cosmWasmContractMsgToJSON = cosmWasmContractMsgToJSON;
function postHandlerFromJSON(postHandlerJSON) {
    if ("wasm_msg" in postHandlerJSON) {
        return {
            wasmMsg: cosmWasmContractMsgFromJSON(postHandlerJSON.wasm_msg),
        };
    }
    return {
        autopilotMsg: postHandlerJSON.autopilot_msg,
    };
}
exports.postHandlerFromJSON = postHandlerFromJSON;
function postHandlerToJSON(postHandler) {
    if ("wasmMsg" in postHandler) {
        return {
            wasm_msg: cosmWasmContractMsgToJSON(postHandler.wasmMsg),
        };
    }
    return {
        autopilot_msg: postHandler.autopilotMsg,
    };
}
exports.postHandlerToJSON = postHandlerToJSON;
function msgsRequestFromJSON(msgsRequestJSON) {
    var _a;
    return {
        sourceAssetDenom: msgsRequestJSON.source_asset_denom,
        sourceAssetChainID: msgsRequestJSON.source_asset_chain_id,
        destAssetDenom: msgsRequestJSON.dest_asset_denom,
        destAssetChainID: msgsRequestJSON.dest_asset_chain_id,
        amountIn: msgsRequestJSON.amount_in,
        amountOut: msgsRequestJSON.amount_out,
        addressList: msgsRequestJSON.address_list,
        operations: msgsRequestJSON.operations.map(operationFromJSON),
        estimatedAmountOut: msgsRequestJSON.estimated_amount_out,
        slippageTolerancePercent: msgsRequestJSON.slippage_tolerance_percent,
        affiliates: (_a = msgsRequestJSON.affiliates) === null || _a === void 0 ? void 0 : _a.map(affiliateFromJSON),
        postRouteHandler: msgsRequestJSON.post_route_handler &&
            postHandlerFromJSON(msgsRequestJSON.post_route_handler),
        clientID: msgsRequestJSON.client_id,
    };
}
exports.msgsRequestFromJSON = msgsRequestFromJSON;
function msgsRequestToJSON(msgsRequest) {
    var _a;
    return {
        source_asset_denom: msgsRequest.sourceAssetDenom,
        source_asset_chain_id: msgsRequest.sourceAssetChainID,
        dest_asset_denom: msgsRequest.destAssetDenom,
        dest_asset_chain_id: msgsRequest.destAssetChainID,
        amount_in: msgsRequest.amountIn,
        amount_out: msgsRequest.amountOut,
        address_list: msgsRequest.addressList,
        operations: msgsRequest.operations.map(operationToJSON),
        estimated_amount_out: msgsRequest.estimatedAmountOut,
        slippage_tolerance_percent: msgsRequest.slippageTolerancePercent,
        affiliates: (_a = msgsRequest.affiliates) === null || _a === void 0 ? void 0 : _a.map(affiliateToJSON),
        post_route_handler: msgsRequest.postRouteHandler &&
            postHandlerToJSON(msgsRequest.postRouteHandler),
        client_id: msgsRequest.clientID,
    };
}
exports.msgsRequestToJSON = msgsRequestToJSON;
function multiChainMsgFromJSON(multiChainMsgJSON) {
    return {
        chainID: multiChainMsgJSON.chain_id,
        path: multiChainMsgJSON.path,
        msg: multiChainMsgJSON.msg,
        msgTypeURL: multiChainMsgJSON.msg_type_url,
    };
}
exports.multiChainMsgFromJSON = multiChainMsgFromJSON;
function multiChainMsgToJSON(multiChainMsg) {
    return {
        chain_id: multiChainMsg.chainID,
        path: multiChainMsg.path,
        msg: multiChainMsg.msg,
        msg_type_url: multiChainMsg.msgTypeURL,
    };
}
exports.multiChainMsgToJSON = multiChainMsgToJSON;
function submitTxRequestFromJSON(submitTxRequestJSON) {
    return {
        tx: submitTxRequestJSON.tx,
        chainID: submitTxRequestJSON.chain_id,
        clientID: submitTxRequestJSON.client_id,
    };
}
exports.submitTxRequestFromJSON = submitTxRequestFromJSON;
function submitTxRequestToJSON(submitTxRequest) {
    return {
        tx: submitTxRequest.tx,
        chain_id: submitTxRequest.chainID,
        client_id: submitTxRequest.clientID,
    };
}
exports.submitTxRequestToJSON = submitTxRequestToJSON;
function submitTxResponseFromJSON(submitTxResponseJSON) {
    return {
        txHash: submitTxResponseJSON.tx_hash,
        success: submitTxResponseJSON.success,
    };
}
exports.submitTxResponseFromJSON = submitTxResponseFromJSON;
function submitTxResponseToJSON(submitTxResponse) {
    return {
        tx_hash: submitTxResponse.txHash,
        success: submitTxResponse.success,
    };
}
exports.submitTxResponseToJSON = submitTxResponseToJSON;
function trackTxRequestFromJSON(trackRequestJSON) {
    return {
        txHash: trackRequestJSON.tx_hash,
        chainID: trackRequestJSON.chain_id,
        clientID: trackRequestJSON.client_id,
    };
}
exports.trackTxRequestFromJSON = trackTxRequestFromJSON;
function trackTxRequestToJSON(trackRequest) {
    return {
        tx_hash: trackRequest.txHash,
        chain_id: trackRequest.chainID,
        client_id: trackRequest.clientID,
    };
}
exports.trackTxRequestToJSON = trackTxRequestToJSON;
function trackTxResponseFromJSON(trackResponseJSON) {
    return {
        txHash: trackResponseJSON.tx_hash,
    };
}
exports.trackTxResponseFromJSON = trackTxResponseFromJSON;
function trackTxResponseToJSON(trackResponse) {
    return {
        tx_hash: trackResponse.txHash,
    };
}
exports.trackTxResponseToJSON = trackTxResponseToJSON;
function txStatusRequestFromJSON(txStatusRequestJSON) {
    return {
        txHash: txStatusRequestJSON.tx_hash,
        chainID: txStatusRequestJSON.chain_id,
        clientID: txStatusRequestJSON.client_id,
    };
}
exports.txStatusRequestFromJSON = txStatusRequestFromJSON;
function txStatusRequestToJSON(txStatusRequest) {
    return {
        tx_hash: txStatusRequest.txHash,
        chain_id: txStatusRequest.chainID,
        client_id: txStatusRequest.clientID,
    };
}
exports.txStatusRequestToJSON = txStatusRequestToJSON;
function chainTransactionFromJSON(chainTransactionJSON) {
    return {
        txHash: chainTransactionJSON.tx_hash,
        chainID: chainTransactionJSON.chain_id,
        explorerLink: chainTransactionJSON.explorer_link,
    };
}
exports.chainTransactionFromJSON = chainTransactionFromJSON;
function chainTransactionToJSON(chainTransaction) {
    return {
        tx_hash: chainTransaction.txHash,
        chain_id: chainTransaction.chainID,
        explorer_link: chainTransaction.explorerLink,
    };
}
exports.chainTransactionToJSON = chainTransactionToJSON;
function packetFromJSON(packetJSON) {
    return {
        sendTx: packetJSON.send_tx && chainTransactionFromJSON(packetJSON.send_tx),
        receiveTx: packetJSON.receive_tx && chainTransactionFromJSON(packetJSON.receive_tx),
        acknowledgeTx: packetJSON.acknowledge_tx &&
            chainTransactionFromJSON(packetJSON.acknowledge_tx),
        timeoutTx: packetJSON.timeout_tx && chainTransactionFromJSON(packetJSON.timeout_tx),
        error: packetJSON.error,
    };
}
exports.packetFromJSON = packetFromJSON;
function packetToJSON(packet) {
    return {
        send_tx: packet.sendTx && chainTransactionToJSON(packet.sendTx),
        receive_tx: packet.receiveTx && chainTransactionToJSON(packet.receiveTx),
        acknowledge_tx: packet.acknowledgeTx && chainTransactionToJSON(packet.acknowledgeTx),
        timeout_tx: packet.timeoutTx && chainTransactionToJSON(packet.timeoutTx),
        error: packet.error,
    };
}
exports.packetToJSON = packetToJSON;
function transferInfoFromJSON(transferInfoJSON) {
    return {
        srcChainID: transferInfoJSON.src_chain_id,
        dstChainID: transferInfoJSON.dst_chain_id,
        state: transferInfoJSON.state,
        packetTXs: transferInfoJSON.packet_txs &&
            packetFromJSON(transferInfoJSON.packet_txs),
    };
}
exports.transferInfoFromJSON = transferInfoFromJSON;
function transferInfoToJSON(transferInfo) {
    return {
        src_chain_id: transferInfo.srcChainID,
        dst_chain_id: transferInfo.dstChainID,
        state: transferInfo.state,
        packet_txs: transferInfo.packetTXs && packetToJSON(transferInfo.packetTXs),
    };
}
exports.transferInfoToJSON = transferInfoToJSON;
function nextBlockingTransferFromJSON(nextBlockingTransferJSON) {
    return {
        transferSequenceIndex: nextBlockingTransferJSON.transfer_sequence_index,
    };
}
exports.nextBlockingTransferFromJSON = nextBlockingTransferFromJSON;
function nextBlockingTransferToJSON(nextBlockingTransfer) {
    return {
        transfer_sequence_index: nextBlockingTransfer.transferSequenceIndex,
    };
}
exports.nextBlockingTransferToJSON = nextBlockingTransferToJSON;
function transferAssetReleaseFromJSON(transferAssetReleaseJSON) {
    return {
        chainID: transferAssetReleaseJSON.chain_id,
        denom: transferAssetReleaseJSON.denom,
    };
}
exports.transferAssetReleaseFromJSON = transferAssetReleaseFromJSON;
function transferAssetReleaseToJSON(transferAssetRelease) {
    return {
        chain_id: transferAssetRelease.chainID,
        denom: transferAssetRelease.denom,
    };
}
exports.transferAssetReleaseToJSON = transferAssetReleaseToJSON;
function txStatusResponseFromJSON(statusResponseJSON) {
    return {
        status: statusResponseJSON.status,
        nextBlockingTransfer: statusResponseJSON.next_blocking_transfer &&
            nextBlockingTransferFromJSON(statusResponseJSON.next_blocking_transfer),
        transferSequence: statusResponseJSON.transfer_sequence.map(transferEventFromJSON),
        transferAssetRelease: statusResponseJSON.transfer_asset_release &&
            transferAssetReleaseFromJSON(statusResponseJSON.transfer_asset_release),
        error: statusResponseJSON.error,
        state: statusResponseJSON.state,
        transfers: statusResponseJSON.transfers.map(transferStatusFromJSON),
    };
}
exports.txStatusResponseFromJSON = txStatusResponseFromJSON;
function txStatusResponseToJSON(statusResponse) {
    return {
        status: statusResponse.status,
        next_blocking_transfer: statusResponse.nextBlockingTransfer &&
            nextBlockingTransferToJSON(statusResponse.nextBlockingTransfer),
        transfer_sequence: statusResponse.transferSequence.map(transferEventToJSON),
        transfer_asset_release: statusResponse.transferAssetRelease &&
            transferAssetReleaseToJSON(statusResponse.transferAssetRelease),
        error: statusResponse.error,
        state: statusResponse.state,
        transfers: statusResponse.transfers.map(transferStatusToJSON),
    };
}
exports.txStatusResponseToJSON = txStatusResponseToJSON;
function ibcAddressFromJSON(ibcAddressJSON) {
    return {
        address: ibcAddressJSON.address,
        chainID: ibcAddressJSON.chain_id,
    };
}
exports.ibcAddressFromJSON = ibcAddressFromJSON;
function ibcAddressToJSON(ibcAddress) {
    return {
        address: ibcAddress.address,
        chain_id: ibcAddress.chainID,
    };
}
exports.ibcAddressToJSON = ibcAddressToJSON;
function axelarTransferFromJSON(axelarTransferJSON) {
    return {
        fromChain: axelarTransferJSON.from_chain,
        fromChainID: axelarTransferJSON.from_chain_id,
        toChain: axelarTransferJSON.to_chain,
        toChainID: axelarTransferJSON.to_chain_id,
        asset: axelarTransferJSON.asset,
        shouldUnwrap: axelarTransferJSON.should_unwrap,
        feeAmount: axelarTransferJSON.fee_amount,
        feeAsset: assetFromJSON(axelarTransferJSON.fee_asset),
        isTestnet: axelarTransferJSON.is_testnet,
    };
}
exports.axelarTransferFromJSON = axelarTransferFromJSON;
function axelarTransferToJSON(axelarTransfer) {
    return {
        from_chain: axelarTransfer.fromChain,
        from_chain_id: axelarTransfer.fromChainID,
        to_chain: axelarTransfer.toChain,
        to_chain_id: axelarTransfer.toChainID,
        asset: axelarTransfer.asset,
        should_unwrap: axelarTransfer.shouldUnwrap,
        fee_amount: axelarTransfer.feeAmount,
        fee_asset: assetToJSON(axelarTransfer.feeAsset),
        is_testnet: axelarTransfer.isTestnet,
    };
}
exports.axelarTransferToJSON = axelarTransferToJSON;
function erc20ApprovalFromJSON(erc20ApprovalJSON) {
    return {
        tokenContract: erc20ApprovalJSON.token_contract,
        spender: erc20ApprovalJSON.spender,
        amount: erc20ApprovalJSON.amount,
    };
}
exports.erc20ApprovalFromJSON = erc20ApprovalFromJSON;
function erc20ApprovalToJSON(erc20Approval) {
    return {
        token_contract: erc20Approval.tokenContract,
        spender: erc20Approval.spender,
        amount: erc20Approval.amount,
    };
}
exports.erc20ApprovalToJSON = erc20ApprovalToJSON;
function evmTxFromJSON(evmTxJSON) {
    return {
        chainID: evmTxJSON.chain_id,
        to: evmTxJSON.to,
        value: evmTxJSON.value,
        data: evmTxJSON.data,
        requiredERC20Approvals: evmTxJSON.required_erc20_approvals.map(erc20ApprovalFromJSON),
    };
}
exports.evmTxFromJSON = evmTxFromJSON;
function evmTxToJSON(evmTx) {
    return {
        chain_id: evmTx.chainID,
        to: evmTx.to,
        value: evmTx.value,
        data: evmTx.data,
        required_erc20_approvals: evmTx.requiredERC20Approvals.map(erc20ApprovalToJSON),
    };
}
exports.evmTxToJSON = evmTxToJSON;
function msgFromJSON(msgJSON) {
    if ("multi_chain_msg" in msgJSON) {
        return {
            multiChainMsg: multiChainMsgFromJSON(msgJSON.multi_chain_msg),
        };
    }
    return {
        evmTx: evmTxFromJSON(msgJSON.evm_tx),
    };
}
exports.msgFromJSON = msgFromJSON;
function msgToJSON(msg) {
    if ("multiChainMsg" in msg) {
        return {
            multi_chain_msg: multiChainMsgToJSON(msg.multiChainMsg),
        };
    }
    return {
        evm_tx: evmTxToJSON(msg.evmTx),
    };
}
exports.msgToJSON = msgToJSON;
function sendTokenTransactionsFromJSON(sendTokenTransactionsJSON) {
    return {
        sendTx: sendTokenTransactionsJSON.send_tx
            ? chainTransactionFromJSON(sendTokenTransactionsJSON.send_tx)
            : null,
        confirmTx: sendTokenTransactionsJSON.confirm_tx
            ? chainTransactionFromJSON(sendTokenTransactionsJSON.confirm_tx)
            : null,
        executeTx: sendTokenTransactionsJSON.execute_tx
            ? chainTransactionFromJSON(sendTokenTransactionsJSON.execute_tx)
            : null,
        error: sendTokenTransactionsJSON.error,
    };
}
exports.sendTokenTransactionsFromJSON = sendTokenTransactionsFromJSON;
function sendTokenTransactionsToJSON(sendTokenTransactions) {
    return {
        send_tx: sendTokenTransactions.sendTx
            ? chainTransactionToJSON(sendTokenTransactions.sendTx)
            : null,
        confirm_tx: sendTokenTransactions.confirmTx
            ? chainTransactionToJSON(sendTokenTransactions.confirmTx)
            : null,
        execute_tx: sendTokenTransactions.executeTx
            ? chainTransactionToJSON(sendTokenTransactions.executeTx)
            : null,
        error: sendTokenTransactions.error,
    };
}
exports.sendTokenTransactionsToJSON = sendTokenTransactionsToJSON;
function contractCallWithTokenTransactionsFromJSON(value) {
    return {
        sendTx: value.send_tx ? chainTransactionFromJSON(value.send_tx) : null,
        gasPaidTx: value.gas_paid_tx
            ? chainTransactionFromJSON(value.gas_paid_tx)
            : null,
        confirmTx: value.confirm_tx
            ? chainTransactionFromJSON(value.confirm_tx)
            : null,
        approveTx: value.approve_tx
            ? chainTransactionFromJSON(value.approve_tx)
            : null,
        executeTx: value.execute_tx
            ? chainTransactionFromJSON(value.execute_tx)
            : null,
        error: value.error,
    };
}
exports.contractCallWithTokenTransactionsFromJSON = contractCallWithTokenTransactionsFromJSON;
function contractCallWithTokenTransactionsToJSON(value) {
    return {
        send_tx: value.sendTx ? chainTransactionToJSON(value.sendTx) : null,
        gas_paid_tx: value.gasPaidTx
            ? chainTransactionToJSON(value.gasPaidTx)
            : null,
        confirm_tx: value.confirmTx
            ? chainTransactionToJSON(value.confirmTx)
            : null,
        approve_tx: value.approveTx
            ? chainTransactionToJSON(value.approveTx)
            : null,
        execute_tx: value.executeTx
            ? chainTransactionToJSON(value.executeTx)
            : null,
        error: value.error,
    };
}
exports.contractCallWithTokenTransactionsToJSON = contractCallWithTokenTransactionsToJSON;
function axelarTransferTransactionsFromJSON(value) {
    if ("contract_call_with_token_txs" in value) {
        return {
            contractCallWithTokenTxs: contractCallWithTokenTransactionsFromJSON(value.contract_call_with_token_txs),
        };
    }
    return {
        sendTokenTxs: sendTokenTransactionsFromJSON(value.send_token_txs),
    };
}
exports.axelarTransferTransactionsFromJSON = axelarTransferTransactionsFromJSON;
function axelarTransferTransactionsToJSON(value) {
    if ("contractCallWithTokenTxs" in value) {
        return {
            contract_call_with_token_txs: contractCallWithTokenTransactionsToJSON(value.contractCallWithTokenTxs),
        };
    }
    return {
        send_token_txs: sendTokenTransactionsToJSON(value.sendTokenTxs),
    };
}
exports.axelarTransferTransactionsToJSON = axelarTransferTransactionsToJSON;
function axelarTransferInfoFromJSON(value) {
    return {
        srcChainID: value.src_chain_id,
        dstChainID: value.dst_chain_id,
        type: value.type,
        state: value.state,
        txs: value.txs && axelarTransferTransactionsFromJSON(value.txs),
        axelarScanLink: value.axelar_scan_link,
    };
}
exports.axelarTransferInfoFromJSON = axelarTransferInfoFromJSON;
function axelarTransferInfoToJSON(value) {
    return {
        src_chain_id: value.srcChainID,
        dst_chain_id: value.dstChainID,
        type: value.type,
        state: value.state,
        txs: value.txs && axelarTransferTransactionsToJSON(value.txs),
        axelar_scan_link: value.axelarScanLink,
    };
}
exports.axelarTransferInfoToJSON = axelarTransferInfoToJSON;
function transferEventFromJSON(value) {
    if ("ibc_transfer" in value) {
        return {
            ibcTransfer: transferInfoFromJSON(value.ibc_transfer),
        };
    }
    return {
        axelarTransfer: axelarTransferInfoFromJSON(value.axelar_transfer),
    };
}
exports.transferEventFromJSON = transferEventFromJSON;
function transferEventToJSON(value) {
    if ("ibcTransfer" in value) {
        return {
            ibc_transfer: transferInfoToJSON(value.ibcTransfer),
        };
    }
    return {
        axelar_transfer: axelarTransferInfoToJSON(value.axelarTransfer),
    };
}
exports.transferEventToJSON = transferEventToJSON;
function transferStatusFromJSON(value) {
    return {
        transferSequence: value.transfer_sequence.map(transferEventFromJSON),
        transferAssetRelease: value.transfer_asset_release &&
            transferAssetReleaseFromJSON(value.transfer_asset_release),
        error: value.error,
        state: value.state,
        nextBlockingTransfer: value.next_blocking_transfer &&
            nextBlockingTransferFromJSON(value.next_blocking_transfer),
    };
}
exports.transferStatusFromJSON = transferStatusFromJSON;
function transferStatusToJSON(value) {
    return {
        transfer_sequence: value.transferSequence.map(transferEventToJSON),
        transfer_asset_release: value.transferAssetRelease &&
            transferAssetReleaseToJSON(value.transferAssetRelease),
        error: value.error,
        state: value.state,
        next_blocking_transfer: value.nextBlockingTransfer &&
            nextBlockingTransferToJSON(value.nextBlockingTransfer),
    };
}
exports.transferStatusToJSON = transferStatusToJSON;
//# sourceMappingURL=converters.js.map